import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Grid, useTheme, TablePagination, Divider } from '@mui/material';
import apiInstance from '../../../services/ServiceApi';
import LineaNegocio from '../../../components/admin/LineaNegocio';
import { CircularProgress } from '@mui/material';
import { ClienteAddModal } from './ClientAddModal';

const BuscarCliente = ({ onSelectClient, onLineaChange }) => {
    const [searchResults, setSearchResults] = useState([]);
    const theme = useTheme();
    const [linea, setLinea] = useState(null);
    const [noResults, setNoResults] = useState(false);
    const [clientSearch, setClientSearch] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [searchData, setSearchData] = useState({
        identificador: '',
        ruc_dni: '',
        telefono: '',
        nombre_completo: '',
    });
 
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }
    const handleLineaChange = (selectedLinea) => {
        setLinea(selectedLinea);
    };

    useEffect(() => {
        if (linea) {
            console.log(linea)
            onLineaChange(linea)
        }
    }, [linea]);


    const handleSearch = () => {
        const searchUrl = `/buscarCliente?linea_negocio_id=${linea.id}&identificador=${searchData.identificador}&page=${page + 1}`;
        setLoading(true);
        apiInstance.get(searchUrl)
            .then(response => {
                const data = response.data;
                if (data.results.length === 0) {
                    setNoResults(true);
                } else {
                    setNoResults(false);
                    setSearchResults(data.results);
                    setTotalPages(Math.ceil(data.count / rowsPerPage));
                }
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setSearchResults([]);
                setLoading(false);
            });
    }

    useEffect(() => {
        if (linea) {
            handleSearch();
        }
    }, [linea, page]);
     
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
 
    return (
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center', 
                margin: 'auto', 
                padding: '2rem', 
                bgcolor: 'background.paper',
                [theme.breakpoints.down('sm')]: {
                    width: '95%',
                    padding: '1rem',
                }
                    }}>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }} >
                    <Grid item style={{ opacity: 0 }}>  {/* Este Grid invisible es para equilibrar el espacio y centrar el título */}
                        <ClienteAddModal style={{ visibility: 'hidden' }} />
                    </Grid>
                    <Grid item >
                        <Typography variant="h4" align="center">Búsqueda de Cliente</Typography>
                    </Grid>
                    <Grid item>
                        <ClienteAddModal />
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <LineaNegocio onLineaChange={handleLineaChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth name="identificador" label="Identificador" variant="outlined" onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth name="nombre_completo" label="Nombre completo" variant="outlined" onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth name="ruc_dni" label="RUC/DNI" variant="outlined" onChange={handleInputChange} /> 
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth name="telefono" label="Teléfono" variant="outlined" onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12}>
                    <Button variant="contained" onClick={handleSearch} disabled={loading}>
                        Buscar
                    </Button>
                    </Grid>
                </Grid>
                {loading && 
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                            <CircularProgress />
                        </Box>
                    }

                <TableContainer component={Paper} sx={{ maxWidth: '100%', overflowX: 'auto', mt: 4 }}>
                    <TextField
                        fullWidth
                        label="Buscar en resultados"
                        variant="outlined"
                        value={clientSearch}
                        onChange={e => setClientSearch(e.target.value)}
                    />
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Nombre Completo</TableCell>
                                <TableCell>Identificador</TableCell>
                                <TableCell sx={{ [theme.breakpoints.down('sm')]: { display: 'none' } }}>Nro.Doc</TableCell>
                                <TableCell sx={{ [theme.breakpoints.down('sm')]: { display: 'none' } }}>Edad</TableCell>
                                <TableCell>Estado</TableCell>
                                <TableCell>Acción</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {searchResults.map((result, index) => (
                                <TableRow key={index}>
                                    <TableCell>{result.id}</TableCell>
                                    <TableCell>
                                        {result.nombre_completo ? result.nombre_completo : `${result.nombre} ${result.apellido_paterno} ${result.apellido_materno}`}
                                    </TableCell>

                                    <TableCell>{result.identificador}</TableCell>
                                    <TableCell sx={{ [theme.breakpoints.down('sm')]: { display: 'none' } }}>{result.numero_documento}</TableCell>

                                    <TableCell sx={{ [theme.breakpoints.down('sm')]: { display: 'none' } }}>{result.edad}</TableCell>
                                    <TableCell>{result.state ? "Activo" : "Inactivo"}</TableCell>
                                    <TableCell>
                                        <Button variant="contained" onClick={() => onSelectClient(result)}>Ver</Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                                    {noResults ? (
                        <Typography variant="h6">No se encontraron resultados</Typography>
                    ) : (
                        <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={totalPages}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
            />
                    )}

            </Box>
    )
}

export default BuscarCliente;
